import { AppStorage } from './appStorage.service';

class AppRequestsCache extends AppStorage {
  save(name, requestFn) {
    const entry = this._getEntry(name);
    return entry ?
      Promise.resolve(entry.value) :
      this._saveEntry(name, requestFn());
  }
  _getStorageKey() {
    return this._appConfiguration.get('storageKeys.requests');
  }
  _entriesEnabled() {
    return true;
  }
}

export { AppRequestsCache };
